jQuery(function ($) {
    $(document).ready(function () {
        // Redoc menu
        setTimeout(function () {
            if ($('.redoc-wrap .menu-content > div > ul').length) {
                $('.redoc-wrap .menu-content label').on('click', function () {
                    // body animate
                    setTimeout(function () {
                        $('html, body').animate({
                            scrollTop: $(window).scrollTop() + 100
                        }, 200);
                    }, 300);
                });
                
                $('.redoc-wrap .menu-content > div > ul').append('<li><label><a href="/">Back to the menu</a></label></li>');
            }
        }, 1000);
        
        // Menu anchors
        checkMenuAnchors();
    });
    
    $(window).on('resize scroll', function() {
        checkMenuAnchors();
    });
    
    function checkMenuAnchors() {
        if ($('.ecs_main_menu .menu-item a').length) {
            $('.ecs_main_menu .menu-item a').each(function () {
                let link = $(this).attr('href').split('#');
                let anchor = link[1];
                
                if (anchor !== undefined && $('#' + anchor).length) {
                    if ($('#' + anchor).isInViewport()) {
                        $(this).addClass('eael-item-active');
                    } else {
                        $(this).removeClass('eael-item-active');
                    }
                }
            });
        }
    }
    
    $.fn.isInViewport = function () {
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
        
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + window.innerHeight;
        
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
});
